// 錄影畫質檔位（`kinio_recording.quality_tier`：0 高 = 主碼流 / 1 標準 = 子碼流，owner 可寫；SPEC #platform-ui-tiers，
// Eddy 2026-10-19 選單）。設定表單的選項上寫這台實際的解析度（高 = `kinio_video.main_resolution`、標準 = `kinio_video.sub_resolution`），
// 設備只宣告 values [high] 時只列高（值域子集，SPEC #contract-device-capabilities；設定投影本身不收窄）。
// 規則與 app/home-base 三平台同一套（web recordingQuality.ts，共用案例 docs/testdata/kinio-recording-quality.json）。

export const QUALITY_TIER_KEY = 'kinio_recording.quality_tier';

const RES_RE = /^(\d+)x(\d+)$/;

function obj(v: unknown): Record<string, unknown> | null {
  return v && typeof v === 'object' && !Array.isArray(v) ? (v as Record<string, unknown>) : null;
}

function tierValue(v: unknown): number | null {
  if (v === 0 || v === 'high') return 0;
  if (v === 1 || v === 'standard') return 1;
  return null;
}

/** thing.capabilities → 可選的 quality_tier 值（enum key 字串）；沒宣告 / 對不上 → null（不收窄）。 */
export function qualityTierValues(capabilities: unknown): Set<string> | null {
  const eff = obj(capabilities)?.effective;
  if (!Array.isArray(eff)) return null;
  const entry = eff.map(obj).find((e) => e?.cluster === 'kinio_recording');
  const vs = obj(entry?.values)?.quality_tier;
  if (!Array.isArray(vs)) return null;
  const out = new Set(vs.map(tierValue).filter((n): n is number => n !== null).map(String));
  return out.size > 0 ? out : null;
}

/** 選項 key（"0" / "1"）→ 這台那一路的解析度（"<寬>x<高>"）；reported 沒報 / 形狀不對 → null。 */
export function qualityTierResolution(reported: Record<string, unknown> | null | undefined, key: string): string | null {
  const video = obj(reported?.kinio_video);
  const v = key === '1' ? video?.sub_resolution : key === '0' ? video?.main_resolution : undefined;
  return typeof v === 'string' && RES_RE.test(v) ? v : null;
}

/** "2560x1440" → { name: "2K", dims: "2560×1440" }；名稱對不上 → name null；形狀不對 → null（同 app/home-base resolutionText）。 */
export function resolutionText(res: string | null | undefined): { name: string | null; dims: string } | null {
  const m = RES_RE.exec(res ?? '');
  if (!m) return null;
  const w = Number(m[1]);
  const h = Number(m[2]);
  if (!(w > 0 && h > 0)) return null;
  const short = Math.min(w, h);
  const px = w * h;
  let name: string | null = null;
  if ([360, 480, 720, 1080].includes(short)) name = `${short}p`;
  else if (px > 2_200_000 && px <= 3_800_000) name = '2K';
  else if (px > 3_800_000 && px <= 6_500_000) name = '3K';
  else if (px > 6_500_000 && px <= 9_500_000) name = '4K';
  return { name, dims: `${w}×${h}` };
}
